export default {
  data : "",
  search_name : ""
};
